






































































































































































































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import { BestCategory, Results } from "@/types/NewResults";
import sampledata from "@/temp/new-results.json";
import ScoreBar from "@/components/results/ScoreBar.vue";
import Transcript from "@/components/results/LearnerTranscript.vue";
import MetricHolder from "@/components/results/MetricHolder.vue";
import Filler from "@/components/results/Filler.vue";
import Energy from "@/components/results/Energy.vue";
import Conciseness from "@/components/results/Conciseness.vue";
import Pace from "@/components/results/Pace.vue";
import Confidence from "@/components/results/Confidence.vue";
import Clarity from "@/components/results/Clarity.vue";
import Expression from "@/components/results/Expression.vue";
import AudioStatement from "@/components/results/AudioStatement.vue";
import Player from "@/components/Player.vue";
import bodymovin from "lottie-web";
import redsvg from "@/assets/images/backgrounds/red.svg";

import { Getter, Action } from "vuex-class";

@Component({
  components: {
    MetricHolder,
    ScoreBar,
    Player,
    Filler,
    Energy,
    Expression,
    Conciseness,
    Pace,
    AudioStatement,
    Clarity,
    Confidence,
    Transcript,
  },
})
export default class LearnerResults extends Vue {
  @Prop() private sid!: String;
  @Prop() private error!: String;
  @Prop() private results!: Results;
  @Action private setRecordedVideoURL!: any;
  @Getter private recordedVideoURL!: string | null;
  private activemetric: string = "";
  private playsegment: number[] = [];
  private otherMetrics: BestCategory[] = [];
  private videoElement!: HTMLVideoElement;

  @Watch("results", { immediate: true })
  private onResultsChange(newResults: Results, oldResults: Results) {
    if (!newResults) {
      return;
    }
    console.log("onResultsChange", newResults, oldResults);
    let summaryCategories: BestCategory[] = [];
    if (newResults.summary.categoriesToWorkOn.length > 0) {
      this.activemetric = newResults.summary.categoriesToWorkOn[0].category;
      summaryCategories = this.results.summary.categoriesToWorkOn.slice();
    } else {
      this.activemetric = newResults.summary.bestCategory.category;
    }

    if (this.results.summary.bestCategory) {
      summaryCategories.push(this.results.summary.bestCategory);
    }
    //console.log(summaryCategories);
    if (this.results.displayCategories.length > 0) {
      this.otherMetrics = [];

      //let result = summaryCategories.filter(o1 => this.results.displayCategories.findIndex(o2 => o1.category.toUpperCase() === o2.toUpperCase())===-1);
      //console.log(result);
      for (let category of this.results.displayCategories) {
        const isOtherCategory = !summaryCategories.some(
          (e: any) => e.category.toUpperCase() === category.toUpperCase()
        );
        console.log(category + "," + isOtherCategory);
        if (isOtherCategory) {
          let score = 0;
          let expression;
          if (category === "fillers") {
            score = this.results.details.fillers.score;
          } else if (category === "confidence") {
            score = this.results.details.confidence.score;
          } else if (category === "conciseness") {
            score = this.results.details.conciseness.score;
          } else if (category === "clarity") {
            score = this.results.details.clarity.score;
          } else if (category === "energy") {
            score = this.results.details.energy.score;
          } else if (category === "pace") {
            score = this.results.details.pace.score;
          } else if (category === "expression") {
            expression = this.results.details.expression.primary.toString();
          }

          const otherCategory = {
            category: category.charAt(0).toUpperCase() + category.slice(1),
            score: score,
            expression: expression,
          };
          this.otherMetrics.push(otherCategory);
        }
        /* if (foundCategory) {
          const latest = foundCategory[foundCategory.length-1];
          //console.log(latest)
          if(!summaryCategories.some((e:any) => e.category.toUpperCase() === latest.category.toUpperCase())) {
            const bestCategory = {
              category: category.charAt(0).toUpperCase() + category.slice(1),
              score: latest.score,
              expression: latest.expression
            }
            this.otherMetrics.push(bestCategory)
          }
        } */
      }
    }

    //console.log(this.otherMetrics);
  }

  private mounted() {
    if (this.$refs.videoelement) {
      (this.$refs.player as Player).video = this.$refs
        .videoelement as HTMLVideoElement;
    }
  }
  private destroyed() {
    this.setRecordedVideoURL(null);
  }
  private playbackurl(): string {
    // if (this.recordedVideoURL && this.recordedVideoURL.length > 0) {
    //   return this.recordedVideoURL!;
    // } else
    if (this.results.videoFileURL && this.results.videoFileURL.length > 0) {
      return this.results.videoFileURL!;
    }
    return this.results.audioFileURL!;
  }

  private setActiveMetric(metric: string) {
    this.activemetric = metric;
  }

  private playAudio(fo: number[]) {
    this.playsegment = fo;
  }

  private getResultBackgroundClass(): string {
    let resultBackgroundClass = "red";
    if (this.results.totalScore >= 85) {
      resultBackgroundClass = "green";
    } else if (this.results.totalScore >= 70) {
      resultBackgroundClass = "yellow";
    }
    return resultBackgroundClass;
  }
}
